import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ekmkzkgw8: FaireProductEntity = {
  token: "p_4ekmkzkgw8",
  type: "product",
  name: "Thanks For the Good Company Letterpress Greeting Card",
  brandToken: "b_4cdthxubt5",
  brandName: "Half Pint Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b846a7e14985b977da195be55a6ceefa3c9a645c0f97e9f7e8a0b1226d951a60.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Letterpress printed greeting card\n\n * Black ink \n * Size: 4-Bar (3.5 x 4.875") \n * Blank on the inside \n * Printed on Ecru White paper \n * Comes with 30% post-consumer waste kraft colored envelope \nAll purchases are shipped first class in protective cellophane wrap. Made in Salt Lake City',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:23.718Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
